/**
 * ==========================================================================
 * Popup TVA Checkout - Thème LDS
 * Notifie les clients professionnels et entreprises d'indiquer leur numéro
 * de TVA intracommunautaire lors de la finalisation de la commande.
 * ==========================================================================
 */

(function () {
  'use strict';

  let isBypassing = false;
  let pendingTrigger = null;

  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[type="submit"][name="checkout"]',
    '.cart-checkout-button',
    '.cart__checkout-button',
    '.checkout-button',
    '#checkout',
    'a[href*="/checkout"]',
    '[data-checkout-button]'
  ].join(', ');

  /**
   * Vérifie si un élément ou l'un de ses parents est un bouton de commande
   */
  function findCheckoutTrigger(element) {
    if (!element || !(element instanceof Element)) return null;
    return element.closest(CHECKOUT_SELECTOR);
  }

  /**
   * Ouvre la modale TVA
   */
  function openModal() {
    const modal = document.getElementById('Vat-Checkout-Modal');
    if (!modal) return;

    if (typeof modal.show === 'function') {
      modal.show();
    } else {
      modal.setAttribute('open', '');
      modal.style.display = 'flex';
      if (window.webvista && typeof window.webvista.disablePageScroll === 'function') {
        window.webvista.disablePageScroll();
      }
    }
  }

  /**
   * Ferme la modale TVA
   */
  function closeModal() {
    const modal = document.getElementById('Vat-Checkout-Modal');
    if (!modal) return;

    if (typeof modal.hide === 'function') {
      modal.hide();
    } else {
      modal.removeAttribute('open');
      modal.style.display = 'none';
      if (window.webvista && typeof window.webvista.enablePageScroll === 'function') {
        window.webvista.enablePageScroll();
      }
    }
  }

  /**
   * Redirection directe vers la page de paiement Shopify
   */
  function directCheckout() {
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = rootUrl.replace(/\/$/, '') + '/checkout';
  }

  /**
   * Procède au paiement après confirmation par le client
   */
  function proceedToCheckout() {
    // Vérifier si la case "Ne plus afficher durant cette session" est cochée
    const sessionCheckbox = document.getElementById('vat-modal-dont-show-session');
    if (sessionCheckbox && sessionCheckbox.checked) {
      try {
        sessionStorage.setItem('vat_checkout_dismissed_session', 'true');
      } catch (e) {
        // En cas de navigation privée avec stockage restreint
      }
    }

    closeModal();

    isBypassing = true;

    const trigger = pendingTrigger;
    pendingTrigger = null;

    if (trigger) {
      // 1. Si c'est un lien standard
      if (trigger.tagName === 'A' && trigger.href) {
        window.location.href = trigger.href;
        return;
      }

      // 2. Si c'est un bouton de formulaire
      let form = null;
      const formId = trigger.getAttribute('form');
      if (formId) {
        form = document.getElementById(formId);
      }
      if (!form) {
        form = trigger.closest('form');
      }

      // Re-cliquer sur le bouton d'origine (permet à BSS B2B ou autres apps d'exécuter leurs hooks)
      if (typeof trigger.click === 'function' && trigger.tagName !== 'FORM') {
        trigger.click();

        // Sécurité : si après 400ms rien ne s'est passé, on force la soumission du formulaire
        setTimeout(function () {
          if (form) {
            submitCheckoutForm(form);
          } else {
            directCheckout();
          }
        }, 400);
        return;
      }

      // 3. Si c'est un formulaire directement
      if (form || trigger.tagName === 'FORM') {
        submitCheckoutForm(form || trigger);
        return;
      }
    }

    // 4. Redirection de secours
    directCheckout();
  }

  /**
   * Soumet un formulaire panier avec le paramètre checkout
   */
  function submitCheckoutForm(form) {
    if (!form) {
      directCheckout();
      return;
    }

    let checkoutInput = form.querySelector('input[name="checkout"]');
    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'Checkout';
      form.appendChild(checkoutInput);
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(checkoutInput);
    } else {
      form.submit();
    }
  }

  /**
   * Interception des clics de checkout en phase de capture
   */
  function handleCaptureClick(event) {
    if (isBypassing) {
      return;
    }

    // Si le client a demandé à ne plus voir le rappel pour cette session
    try {
      if (sessionStorage.getItem('vat_checkout_dismissed_session') === 'true') {
        return;
      }
    } catch (e) {}

    const trigger = findCheckoutTrigger(event.target);
    if (!trigger) return;

    // Ne pas intercepter si le clic provient de notre propre modale
    if (trigger.closest('#Vat-Checkout-Modal')) return;

    // Intercepter l'action
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    pendingTrigger = trigger;
    openModal();
  }

  /**
   * Interception des soumissions de formulaire (ex: touche Entrée)
   */
  function handleCaptureSubmit(event) {
    if (isBypassing) {
      return;
    }

    try {
      if (sessionStorage.getItem('vat_checkout_dismissed_session') === 'true') {
        return;
      }
    } catch (e) {}

    const form = event.target;
    if (!form || !(form instanceof HTMLFormElement)) return;

    // Vérifier si le formulaire est le panier
    const isCartForm = (form.action && form.action.includes('/cart')) || (form.id && form.id.includes('Cart-From'));
    if (!isCartForm) return;

    const submitter = event.submitter;
    // Si la soumission n'est pas le passage en caisse (ex: note de panier ou code promo), laisser passer
    if (submitter && submitter.getAttribute('name') && submitter.getAttribute('name') !== 'checkout') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    pendingTrigger = submitter || form;
    openModal();
  }

  /**
   * Initialisation des écouteurs
   */
  function init() {
    // Écouteurs globaux de checkout
    document.addEventListener('click', handleCaptureClick, true);
    document.addEventListener('submit', handleCaptureSubmit, true);

    // Écouteurs de la modale TVA
    const proceedBtn = document.getElementById('VatModalProceedBtn');
    if (proceedBtn) {
      proceedBtn.addEventListener('click', function (e) {
        e.preventDefault();
        proceedToCheckout();
      });
    }

    const backBtn = document.getElementById('VatModalBackBtn');
    if (backBtn) {
      backBtn.addEventListener('click', function (e) {
        e.preventDefault();
        pendingTrigger = null;
        closeModal();
      });
    }

    const closeBtn = document.getElementById('VatModalCloseBtn');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        pendingTrigger = null;
        closeModal();
      });
    }

    const overlay = document.getElementById('VatModalOverlay');
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        e.preventDefault();
        pendingTrigger = null;
        closeModal();
      });
    }

    // Fermeture avec la touche Échap
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        const modal = document.getElementById('Vat-Checkout-Modal');
        if (modal && (modal.hasAttribute('open') || modal.style.display === 'flex')) {
          pendingTrigger = null;
          closeModal();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
